import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: false,
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.scss'],
})
export class SelectLanguageComponent {
  constructor(public translate: TranslateService) {}

  selectLang(lang: string) {
    this.translate.use(lang);
  }
}
